import { ArrowChevronRight } from '@teamsparta/stack-icons';
import { vars } from '@teamsparta/stack-tokens';
import Image from 'next/image';
import { useState } from 'react';

import { copyToClipboard } from '@/lib/utils/clipboard';
import { getCookie } from '@/lib/utils/cookie';
import { useLoginModal } from '@/store/login';

import { extractImageName } from '../logic';
import * as PS from '../style';
import type { ImageWithButtonDiv } from '../type';
import * as S from './style';

export default function ImageWithButtonDivFrame({
  div,
}: {
  div: ImageWithButtonDiv;
}) {
  return (
    <PS.DivWrapper id={div.tagId} bgColor={div.bgColor}>
      <S.MobileImageWrapper>
        <Image
          src={div.mobileImageUrl}
          alt={extractImageName(div.mobileImageUrl)}
          layout='fill'
          objectFit='cover'
        />
        <Button button={div.button} />
      </S.MobileImageWrapper>
      <DesktopLayout div={div} />
    </PS.DivWrapper>
  );
}

function Button({ button }: { button: ImageWithButtonDiv['button'] }) {
  const iconColor = {
    scc: `${vars.neutral[0]}`,
    darkGray: `${vars.neutral[10]}`,
    white: `${vars.neutral[80]}`,
  };
  const { open: setLoginModal } = useLoginModal();
  const checkIsLogin = () => {
    const hasUserInfoCookie = getCookie('userinfo');
    const hasAccessTokenCookie = getCookie('token');

    return hasUserInfoCookie && hasAccessTokenCookie;
  };

  function handleButtonClick() {
    if (button.hasLoginOption && !checkIsLogin()) {
      setLoginModal(button.url);
      return;
    }

    if (button.hasCopyOption) {
      copyToClipboard(button.url);
      window.alert('링크가 복사되었습니다.!');
      return;
    }

    button.isNewTab
      ? window.open(button.url, '_blank')
      : (window.location.href = button.url);
  }

  return (
    <S.CustomButtonWrapper button={button} onClick={handleButtonClick}>
      {button.text}
      {button.withIcon && (
        <ArrowChevronRight size={16} color={iconColor[button.style]} />
      )}
    </S.CustomButtonWrapper>
  );
}

function DesktopLayout({ div }: { div: ImageWithButtonDiv }) {
  const [imageLoaded, setImageLoaded] = useState(false);

  if (div.button.position === 'underTitle') {
    return (
      <S.UnderTitleWrapper>
        <S.DesktopImageWrapper width={div.width} height={div.height}>
          <Image
            src={div.desktopTitleImageUrl}
            alt={extractImageName(div.desktopTitleImageUrl)}
            layout='fill'
            objectFit='cover'
          />
          <Button button={div.button} />
        </S.DesktopImageWrapper>
        <S.SecondDesktopImageWrapper width={div.width} height={div.height}>
          <Image
            src={div.desktopImageUrl}
            alt={extractImageName(div.desktopImageUrl)}
            layout='fill'
            objectFit='cover'
          />
        </S.SecondDesktopImageWrapper>
      </S.UnderTitleWrapper>
    );
  }

  return (
    <S.BottomCenterWrapper>
      <S.DesktopImageWrapper>
        <Image
          src={div.desktopImageUrl}
          alt={extractImageName(div.desktopImageUrl)}
          layout='fill'
          objectFit='cover'
          onLoadingComplete={() => setImageLoaded(true)}
        />
      </S.DesktopImageWrapper>
      {imageLoaded && <Button button={div.button} />}
    </S.BottomCenterWrapper>
  );
}
